import request from '@/utils/request'

const tradecollectionAttachmentApi = {
  trade_collection_attachment_list: '/trade/collection_attachment/',
  trade_collection_attachment_create: '/trade/collection_attachment/',
  trade_collection_attachment_update: '/trade/collection_attachment/',
  trade_collection_attachment_delete: '/trade/collection_attachment/'
}

/**
 * 列表
 */
export function collection_attachment_list (parameter) {
  return request({
    url: tradecollectionAttachmentApi.trade_collection_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function collection_attachment_create (parameter) {
  return request({
    url: tradecollectionAttachmentApi.trade_collection_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function collection_attachment_update (parameter, collection_attachment_id) {
  return request({
    url: tradecollectionAttachmentApi.trade_collection_attachment_update + collection_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function collection_attachment_delete (collection_attachment_id) {
  return request({
    url: tradecollectionAttachmentApi.trade_collection_attachment_delete + collection_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
